module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('spotin-com-icon', {
    staticClass: "icon",
    class: _vm.computedClass,
    style: ({
      color: _vm.computedColor
    })
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49a8ff02","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/globalBlocks/Icon.vue
// module id = 540
// module chunks = 0